































import {
  computed,
  defineComponent,
  inject,
  ref,
} from '@nuxtjs/composition-api'
import { SfHeading, SfButton } from '@storefront-ui/vue'
import ToggleCheck from './ToggleCheck.vue'

export default defineComponent({
  name: 'StockStatusFilter',
  props: {
    title: {
      type: String,
      default: '',
    }
  },
  components: {
    SfHeading,
    SfButton,
    ToggleCheck,
  },
  emits: ['selectFilter'],
  setup(props, { emit }) {
    const attributeCode = 'wm_product_in_stock'

    const isOpen = ref(true)

    const { isFilterSelected } = inject('UseFiltersProvider')

    const isToggled = computed(() => !!isFilterSelected(attributeCode, '1'))

    const emitChange = (value: boolean) => {
      emit('selectFilter', {
        attributeCode,
        value: value ? '1' : '0',
      })
    }

    return {
      attributeCode,
      emitChange,
      isOpen,
      isToggled,
    }
  }
})
